module.exports = __webpack_public_path__ + "img/gallery_bg_1.21cd38a8.jpg";